import React from "react";
import Card from "react-bootstrap/Card";
import { Row, Col } from "react-bootstrap";
import readmore from "../../Assets/Work/readmore.svg";
function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title className="card-title project-title">{props.title}</Card.Title>
        <Card.Text  className="content card-description">
          {props.description}
          
          {/* <hr className="white-line"></hr> */}
        </Card.Text>
        <Row style={{margin:"10px"}}>
          <Col>
          {/* <Button variant="primary" href={props.ghLink} target="_blank">
          GitHub
        </Button> */}
        </Col>
        </Row>

      </Card.Body>
      <div className="readmore" >
        <span className="hide">Read More</span> <img className="rm-img" alt="readmore-img" src={readmore} />
        </div>
    </Card>
  );
}
export default ProjectCards;
